import React, { FC }  from 'react';
import * as Yup       from "yup";
import _              from "underscore";
import { Cell, Grid } from "styled-css-grid";

import { useFeatureFlags }                                                                                                       from "@src/hooks";
import { Uuid }                                                                                                                  from '@src/types';
import { BusinessFunctionDropdown }                                                                                              from "@src/views/components/forms";
import { BulkUpdateFormControlContainer }                                                                                        from "@src/views/pages/projects/activities/bulk/BulkUpdateFormControlContainer";
import { ProjectActivityBulkUpdateShell, ProjectActivityBulkUpdateShellFormContainerProps, ProjectActivityBulkUpdateShellProps } from "@src/views/pages/projects/activities/bulk/ProjectActivityBulkUpdateShell";
import { ProjectActivityBulkUpdateMultiDialogProps }                                                                             from "@src/views/pages/projects/operations/ProjectActivityBulkUpdateMultiDialog";
import { ENTITY_ICONS }                                                                                                          from "@src/constants";


type FormTypeAttributes = {
    businessFunctionId: Uuid,
}

const formDefaultValues = {
    businessFunctionId: null,
};

const validationSchema = (
    Yup.object().shape( {
        businessFunctionId: Yup.string().nullable().required('Choose a business function.'),
    } )
);

const mutationAttributeFormatter: ProjectActivityBulkUpdateShellProps<FormTypeAttributes>['prepareFormValuesForMutation'] = ( values, formik ) => {

    const { businessFunctionId } = values;

    const changes: Record<any, any> = {};

    if( !_.isEmpty( businessFunctionId ) ){
        changes.businessFunctionId = businessFunctionId;
    }

    return changes;
};

interface StaticProjectActivityBulkUpdateBusinessFunctionProps extends Pick<ProjectActivityBulkUpdateShellProps<FormTypeAttributes>, 'supportModals' | 'supportToasts'>,
    Pick<ProjectActivityBulkUpdateMultiDialogProps, 'projectId' | 'projectVersionId' | 'projectActivityIds'> {
    formContainer: FC<ProjectActivityBulkUpdateShellFormContainerProps>;
}

const StaticProjectActivityBulkUpdateBusinessFunctionDefaultProps = {
    supportModals: false,
    supportToasts: true,
} satisfies Partial<StaticProjectActivityBulkUpdateBusinessFunctionProps>;

function StaticProjectActivityBulkUpdateBusinessFunction( _props: StaticProjectActivityBulkUpdateBusinessFunctionProps ){

    const props = { ...StaticProjectActivityBulkUpdateBusinessFunctionDefaultProps, ..._props };

    const featureFlags = useFeatureFlags();

    return (

        <ProjectActivityBulkUpdateShell<FormTypeAttributes>
            projectId={ props.projectId }
            projectVersionId={ props.projectVersionId }
            ids={ props.projectActivityIds }
            supportToasts={ props.supportToasts }
            supportModals={ props.supportModals }
            defaultFormValues={ formDefaultValues }
            validationSchema={ validationSchema }
            formContainer={ props.formContainer }
            prepareFormValuesForMutation={ mutationAttributeFormatter }>

            {/* FORM CONTENT */ }
            { ( { formik, isProcessing, isLoading } ) => {

                return (

                    <BulkUpdateFormControlContainer
                        icon={ ENTITY_ICONS.BUSINESS_FUNCTIONS.ENTITY }
                        title={ 'Update Business Function' }
                        description={ `Migrate the business function for multiple activities to the one specified.` }>

                        <Grid columns={ `1fr` } rows={ `auto auto` } columnGap={ "30px" } rowGap={ '30px' }>
                            <Cell>

                                <BusinessFunctionDropdown
                                    label={ "Business Function" }
                                    descriptionText={ `The general business function for which these activities should be associated with.` }
                                    name={ "businessFunctionId" }
                                    disabled={ isLoading || isProcessing }
                                    allowArchived={ false }
                                />
                            </Cell>
                        </Grid>

                    </BulkUpdateFormControlContainer>

                );
            } }

        </ProjectActivityBulkUpdateShell>

    );
}

export {
    StaticProjectActivityBulkUpdateBusinessFunction,
    StaticProjectActivityBulkUpdateBusinessFunctionDefaultProps,
    type StaticProjectActivityBulkUpdateBusinessFunctionProps,
};
